export default __webpack_public_path__ + "static/media/google-calendar.9087ea08.svg";